<div
  class="flex flex-col h-full bg-drawer transition-all duration-300"
  [ngClass]="{
    'relative w-3xs z-30': !isMobile() && isDrawerOpen(),
    'w-0 overflow-hidden': !isMobile() && !isDrawerOpen(),
    'fixed top-0 left-0 w-64 h-screen z-30': isMobile() && isDrawerOpen(),
    'hidden': isMobile() && !isDrawerOpen()
  }">

  <!-- Drawer header -->
  <a routerLink="/" class="h-12 flex items-center">
    <img class="mx-auto h-8 w-auto" [src]="logoBase + '_' + (layoutStore.themeColor() === Theme.dark ? 'WY' : 'BY') + '.svg'" [alt]="'drawer.altLogo' | translate">
  </a>

  <!-- Nav -->
  <nav class="flex-1 app-scrollbar p-2 pb-2 space-y-1 text-sm">
    <!-- Fav -->
    @if (layoutStore.favUrls().length) {
      <div class="flex h-8 shrink-0 items-center px-2 text-xs font-medium text-muted">{{ 'drawer.bookmarks' | translate }}</div>
      @for (url of layoutStore.favUrls(); let i = $index; track url) {
        <div class="flex items-center group rounded-lg" [ngClass]="isActive(url) ? 'bg-primary-50' : 'hover:bg-drawer-hover'">
          @if (!isMobile()) {
            <button (click)="toggleFav(url)" class="flex-none ps-3 text-transparent group-hover:text-muted/50 hover:text-primary transition-colors duration-150">
              <span class="fas fa-star fa-2xs"></span>
            </button>
          }
          <a
            [routerLink]="url"
            (click)="closeDrawerOnMobile()"
            class="grow py-1 ps-5 pe-3 flex justify-between"
            [ngClass]="{ 'ml-5': isMobile(), 'text-primary font-medium': isActive(url) }"
            [hotkeysGroup]="'drawer.bookmarks' | translate"
            [hotkeys]="getShortcut(i)"
            [hotkeysDescription]="('shortcuts.goTo' | translate) + (getLinkTitle(url) | translate)"
            [isGlobal]="true"
            (hotkey)="goTo(url)">
            <span>{{ getLinkTitle(url) | translate }}</span>
            @if (!isMobile()) {
              <app-shortcut [hotkey]="getShortcut(i)"></app-shortcut>
            }
          </a>
        </div>
      }
    }

    <!-- All links -->
    <div class="flex h-8 shrink-0 items-center px-2 text-xs font-medium text-muted">{{ 'drawer.pages' | translate }}</div>
    @for (link of links; track $index) {
      @if (isAllowed(link.allowedRoles)) {
        @if (link.items?.length) {
          <div class="flex items-center rounded-lg group" [ngClass]="isActive(link.url, true) ? 'bg-primary-50' : 'hover:bg-drawer-hover'">
            <a [routerLink]="link.url" (click)="closeDrawerOnMobile()" class="flex grow items-center px-3 py-1" [ngClass]="isActive(link.url, true) ? 'text-primary font-medium' : ''">
              <span [class]="link.icon + ' fa-fw'" [ngClass]="isActive(link.url, true) ? 'text-primary' : 'text-muted'"></span>
              <span class="grow px-3">
                {{ link.title | translate }}
              </span>
            </a>
            <button type="button" (click)="toggleIsCollapsed(link.title)" class="flex-none px-3 text-muted/50 hover:text-primary transition-colors">
              <span class="fas fa-fw text-xs" [ngClass]="link.isCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"></span>
            </button>
          </div>
        } @else {
          <div class="flex group rounded-lg" [ngClass]="isActive(link.url) ? 'bg-primary-50' : 'hover:bg-drawer-hover'">
            <a [routerLink]="link.url" (click)="closeDrawerOnMobile()" class="grow flex items-center px-3 py-1" [ngClass]="isActive(link.url) ? 'text-primary font-medium' : ''">
              <span [class]="link.icon" [ngClass]="isActive(link.url) ? 'text-primary' : 'text-muted'"></span>
              <span class="ps-3">{{ link.title | translate }}</span>
            </a>
            @if (!isMobile()) {
              <button (click)="toggleFav(link.url!)" class="flex-none pe-3 text-transparent group-hover:text-muted/50 hover:text-primary transition-colors duration-150">
                @if (isFavItem(link.url!)) {
                  <span class="fas fa-star fa-2xs"></span>
                } @else {
                  <span class="far fa-star fa-2xs"></span>
                }
              </button>
            }
          </div>
        }
      }

      @if (link.items?.length && !link.isCollapsed) {
        <div class="ml-5 ps-2 border-l border-border">
          @for (item of link.items; track item.url) {
            @if (isAllowed(item.allowedRoles)) {
              <div class="flex group rounded-lg" [ngClass]="isActive(item.url) ? 'bg-primary-50' : 'hover:bg-drawer-hover'">
                <a [routerLink]="item.url" (click)="closeDrawerOnMobile()" class="grow py-1 pl-3" [ngClass]="isActive(item.url) ? 'text-primary font-medium' : ''">{{ item.title | translate }}</a>
                @if (!isMobile()) {
                  <button (click)="toggleFav(item.url)" class="flex-none pe-3 text-transparent group-hover:text-muted/50 hover:text-primary transition-colors duration-150">
                    @if (isFavItem(item.url)) {
                      <span class="fas fa-star fa-2xs"></span>
                    } @else {
                      <span class="far fa-star fa-2xs"></span>
                    }
                  </button>
                }
              </div>
            }
          }
        </div>
      }
    }
  </nav>

  <!-- User card -->
  <div class="m-2">
    <app-user-menu (closeDrawerOnMobile)="closeDrawerOnMobile()"></app-user-menu>
  </div>

  <!-- Collapsible border -->
  @if (!isMobile() && isDrawerOpen()) {
    <button
      (click)="toggleDrawer.emit()"
      class="absolute top-0 right-0 h-full w-3 flex items-center justify-center border-r border-border transition-all duration-100 hover:border-r-2"
      [ngClass]="isDrawerOpen() ? 'cursor-w-resize!' : 'cursor-e-resize!'"
      [title]="'drawer.reduce' | translate">
    </button>
  }
</div>
